<template>
  <div>
    <VideoJS/>
  </div>
</template>

<script>
import VideoJS from '@/components/VideoJS.vue'

export default {
  name: 'Player',
  components: {
    VideoJS
  }
}
</script>
